import "./PipeProducts.module.css";
import Header from "@/reusable_sections/Header";
import ProductosTuberA from "./sections/ProductosTuberA";
import Footer from "@/reusable_sections/Footer";
export default function PipeProductsPage() {
  return <div>
      <Header />
      <ProductosTuberA />
      <Footer />
    </div>;
}